import React from "react";
import { connect } from "react-redux";
import ContentEditable from "react-contenteditable";
import JirangoButton from "../../cms/components/UI/Buttons/JirangoButton";
import StyleWrapper from "../../cms/areas/template/components/StyleWrapper";
import TinyEditor from "../../cms/components/plugins/tiny_plugin/TinyEditor";
import { sourceTypes } from "../../constants/cms/sourceType";
import "./EventLabel.css";
import MapContainer from "../../cms/components/plugins/GoogleMaps/MapContainer";
import { toKebabCase } from "../../helpers/cssHelper";
import { ReCaptchaContainer } from "../../cms/elements/element/Content/Widgets/ReCaptchaContainer/ReCaptchaContainer";
import VideoElement from "../../cms/elements/element/Content/Widgets/VideoElement";
import ImageElement from "../../cms/elements/element/Content/Widgets/ImageElement/ImageElement";
import { compareDates } from "../../helpers/dateHelper";
import CountdownTimer from "../../components/CountdownTimer";
import CalendarInvitation from "../../cms/elements/element/CalendarInvitation/CalendarInvitation";

const defaultImage = "https://images.unsplash.com/photo-1517484030358-fd0cca3d33d0?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60";

class EventLabel extends React.PureComponent {
  state = {
    editor: {},
    isMediaVaultOpen: false,
    isCropping: false,
    containerStyle: null,
    baseValue: 0,
    saveCrop: false,
    style: "",
    marginTop: 0,
    reRender: false,
    data: null,
    imageLoaded: false,
    buttonShow: false,
  };
  buttonTimeHandler = () => {
    const { editMode } = this.props.cms;
    const { timer, endDate, startDate } = this.props.settings;
    /*     let endDate = new Date().getTime() + 1 * 60000; */
    if (!timer) {
      this.setState({ buttonShow: true });
      return;
    }
    if (startDate || endDate) {
      if (startDate && !this.state.buttonShow && compareDates(startDate)) {
        if (!endDate || (endDate && +new Date() < +new Date(endDate))) {
          this.setState({ buttonShow: true });
        }
      } else if (endDate && +new Date() > +new Date(endDate)) {
        this.setState({ buttonShow: false });
      } else {
        this.buttonTimer = setInterval(() => {
          if (startDate && !this.state.buttonShow && compareDates(startDate)) {
            if (!endDate || (endDate && +new Date() < +new Date(endDate))) {
              this.setState({ buttonShow: true });
              if (!endDate) clearInterval(this.buttonTimer);
            }
          }
          if (endDate && +new Date() > +new Date(endDate)) {
            this.setState({ buttonShow: false });
            clearInterval(this.buttonTimer);
          }
        }, 10000);
      }
    } else {
      this.setState({ buttonShow: true });
    }
  };
  componentDidMount() {
    this.buttonTimeHandler();
    if (this.props.settings.style !== undefined && this.props.settings.style.maxHeight !== undefined && this.props.settings.style.maxHeight !== "unset") {
      this.setState({
        containerStyle: {
          height: this.imgRef.clientHeight,
          width: this.imgRef.clientWidth,
          baseValue: this.imgRef.clientHeight,
        },
      });
      if (this.props.type === "IMG" && this.props.settings.type === "FULL" && this.props.v === "") {
        this.props.onChange(this.props.settings.style.maxHeight + "px", "data.style.maxHeight");
      }
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.settings.style !== undefined && this.props.settings.style.maxHeight !== undefined && this.state.imageLoaded && this.imgRef && this.props.value !== prevProps.value) {
      this.setState({
        containerStyle: {
          height: this.imgRef.clientHeight,
          width: this.imgRef.clientWidth,
          baseValue: this.imgRef.clientHeight,
        },
      });
      if (this.props.type === "IMG" && this.props.settings.type === "FULL") {
        if (this.props.value && this.props.value.toString().includes("cropped")) return;
        this.props.onChange(this.imgRef.clientHeight + "px", "data.style.maxHeight");
      }
    }
  }
  componentWillUnmount() {
    if (this.buttonTimer) clearInterval(this.buttonTimer);
  }
  setImageHeight = () => {};
  handleOnChange = (value) => {
    this.props.onChange(value, "props.value", this.props.contentId);
  };
  handleExtra = (path, value) => {
    this.props.onChange(value, path);
  };
  changeImage = (url) => {
    this.setState(
      {
        isMediaVaultOpen: false,
      },
      () => {
        this.props.onChange(url, "props.value");
      }
    );
  };
  setImage = (url) => {
    this.handleOnChange(url);
  };
  toggleMediaVault = () => {
    this.setState({ isMediaVaultOpen: !this.state.isMediaVaultOpen });
  };
  toggleCroppie = () => {
    if (!this.state.containerStyle) {
      this.setState({
        containerStyle: {
          height: this.imgRef.clientHeight,
          width: this.imgRef.clientWidth,
        },
        isCropping: !this.state.isCropping,
      });
    } else {
      this.setState({ isCropping: !this.state.isCropping });
    }
  };
  handleCropSave = (value) => {
    this.setState({ value: value }, () => {
      this.setImage(value);
      this.setState({ isCropping: false });
    });
  };
  handleImageLoaded = () => {
    this.setState({ imageLoaded: true });
  };
  imageAlignment = (pos) => {
    switch (pos) {
      case "center":
        return "0px auto 0px auto";
      case "right":
        return "0px 0px 0px auto";
      case "left":
        return "0px auto 0px 0px";
      default:
        return "0px auto 0px auto";
    }
  };
  render() {
    const { form, cms, template, selectedElement } = this.props;
    const { settings, type, value, contentId, data, isColumnChild, onSelect } = this.props;
    let v = "";
    if (!value && (type === "TEXT" || type === "BUTTON")) v = `<p>Text</p>`;
    else if (value === "" && type === "IMG") v = defaultImage;
    else v = value;
    return (
      <React.Fragment>
        {type && (
          <div
            ref={(r) => (this.imgRef = r)}
            className={"responsive-col-image"}
            style={{
              height: "auto",
              width: "100%",
              display: type === "MAP" ? "grid" : "flex",
            }}
          >
            {type === "IMG" && <ImageElement {...this.props} />}
            {type === "TEXT" && (
              <React.Fragment>
                {cms.editMode /*  && selectedElement && selectedElement.contentId === contentId */ ? (
                  <div className="styleWrapper" style={{ width: "100%" }}>
                    <style>{`${toKebabCase(template.template.content, true)} ${!selectedElement ? ".tox-tinymce { opacity: 0}" : ""}`}</style>
                    <TinyEditor
                      value={v}
                      editMode={selectedElement && selectedElement.contentId === contentId}
                      onChange={this.handleOnChange}
                      style={/* template.template ? toKebabCase(template.template.content, false) :  */ ""}
                    />
                  </div>
                ) : (
                  <div className="styleWrapper" style={{ width: "100%" }}>
                    <StyleWrapper
                      order={this.props.attendee && this.props.attendee.orders ? this.props.attendee.orders[0] : null}
                      isPage={this.props.cms.enviroment === sourceTypes.PAGE}
                      isHeaderText={this.props.isHeaderText}
                      template={template.template ? toKebabCase(template.template.content, true) : ""}
                      lang={this.props.lang}
                      content={v}
                    />
                  </div>
                )}
              </React.Fragment>
            )}
            {type === "DIVIDER" && (
              <React.Fragment>
                <hr
                  style={{
                    marginTop: settings.height / 2 + "px",
                    marginBottom: settings.height / 2 + "px",
                    /*   height: "1px", */
                    borderColor: settings.borderColor,
                    borderWidth: settings.borderWidth + "px",
                    borderStyle: settings.borderStyle,
                    width: settings.width + "%",
                  }}
                />
              </React.Fragment>
            )}
            {type === "MAP" ? <MapContainer address={v} zoom={settings.zoom} height={settings.style.height} /> : null}
            {type === "CALENDAR_INVITATION" ? <CalendarInvitation {...this.props} /> : null}
            {type === "BUTTON" ? (
              <div className="button-wrapper">
                {settings.timer && settings.startDate ? <CountdownTimer datetime={settings.startDate} /> : null}
                <JirangoButton
                  style={{
                    ...this.props.template.template.content.button,
                    margin: this.imageAlignment(settings.alignment),
                    /*   padding: settings.padding, */
                  }}
                  disabled={cms.editMode || !this.state.buttonShow}
                  settings={settings}
                  onClick={() =>
                    settings.actionLink
                      ? window.open(
                          convertUrl(
                            settings.actionLink,
                            this.props.attendee !== undefined && this.props.attendee.orders !== undefined && this.props.attendee.orders.length > 0 ? this.props.attendee.orders[0] : null
                          ),
                          `_${settings.target}`
                        )
                      : null
                  }
                >
                  <style>
                    {`.jir-cms-btn-text p {
                        margin-bottom: 0px;
                      }`}
                  </style>
                  <ContentEditable
                    className="jir-cms-btn-text"
                    style={{
                      minWidth: "20px",
                      color: template.template.content.button.color,
                      marginBottom: "0px",
                    }}
                    innerRef={this.contentEditable}
                    html={v}
                    contentEditable={cms.editMode}
                    disabled={!cms.editMode}
                    onChange={(e) => this.handleOnChange(e.target.value)}
                    tagName="p"
                  />
                </JirangoButton>
              </div>
            ) : null}
            {type === "FILTER" ? <ReCaptchaContainer /> : null}
            {type === "VIDEO" ? (
              <VideoElement
                style={{
                  ...settings.style,
                  margin: this.imageAlignment(settings.alignment),
                }}
                /*       editMode={cms.editMode} */
                /*          selected={(selectedElement && selectedElement.contentId === contentId)} */
                loop={settings.loop}
                url={v}
                thumbnail={settings.thumbnail}
                /*       element={form.formElements.find(e => { return e.contentId === contentId })} */
                autoplay={settings.autplay}
                frame={settings.frame}
              />
            ) : null}
          </div>
        )}
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  let selectedElement = null;
  let lang = undefined;
  if (state.cms.enviroment === sourceTypes.TEMPLATE) {
    selectedElement = state.template.selectedElement;
  }
  if (state.cms.enviroment === sourceTypes.PAGE) {
    selectedElement = state.page.selectedElement;
    lang = state.page.languageCode;
  }
  if (state.cms.enviroment === sourceTypes.FORM) {
    selectedElement = state.form.selectedElement;
    lang = state.form.languageCode;
  }
  return {
    alert: state.alert,
    form: state.form,
    cms: state.cms,
    attendee: state.attendee,
    selectedElement,
    template: state.template,
    language: state.language,
    page: state.page,
    attendee: state.attendee,
    lang,
  };
}
export default connect(mapStateToProps)(EventLabel);

function convertUrl(url, order) {
  var newUrl = new URL(url);
  let params = newUrl.search;
  if (/\[badgeno\]|\[clientkey\]/gi.test(params)) {
    params = params.replace(/\[badgeno\]|\[clientkey\]/gi, order ? order.badgeNo : "");
    var basicUrl = newUrl.origin + newUrl.pathname + (order && order.badgeNo ? params : "");
    return basicUrl;
  }
  return url;
}
